module.exports = __webpack_public_path__ + "static/black-friday-featured-97e4a170c24f26db277c07e108a0f310.png";